var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.eligibility)?_c('renewal-opt-in-modal',{attrs:{"visible":_vm.isModalVisible,"eligibility":_vm.eligibility},on:{"update:visible":function($event){_vm.isModalVisible=$event}}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b26e15","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/membership-renewal-opt-in/renewal-opt-in-coordinator.vue
// module id = null
// module chunks = 